module.exports = {"path":["Dashboard","Accounting","Accounting Management"]}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/indivi/index.json
// module id = IvGP
// module chunks = 58